import senadoLogo from "@/core/assets/img/cabecalhos-pdf/senado-logo.jpg";
import { obterDataFormatada, obterHoraFormatada } from "../../utils";

export function createHeaderSenado(doc) {
  doc.addImage(senadoLogo, "JPEG", 8, 10, 35, 10);
  doc.setFont("", "bold");

  doc.text("RELATÓRIO IBP - DADOS ", 44, 14, null, null);
  doc.text("CADASTRAIS DA CARGA PATRIMONIAL", 44, 20, null, null);

  doc.setFont("", "normal");

  doc.setFontSize(10);
  doc.text(
    "Emitido no dia " + obterDataFormatada() + " as " + obterHoraFormatada(),
    203,
    12,
    null,
    null,
    "right"
  );

  doc.text("Página 1 / 1", 283, 22, null, null, "right");

  return doc;
}
